var EPK = EPK || {};
EPK.LpAga = EPK.LpAga || {};
EPK.LpAga.$loadFilter = $('.loading-filter');
EPK.LpAga.$hospitalCalendarBox = $('.hospital-calendar-box');
EPK.LpAga.$signinModal = $('.signin_modal');
EPK.LpAga.$hospitalCalendarScrollBox = $('.hospital-calendar-scrollbox');
EPK.LpAga.$weekChangeButton = $('.previous-week , .next-week');

$(function() {

    $(document).on('click','.reserve_list_day',function() {
/*
		EPK.LpAga.$hospitalCalendarScrollBox.addClass('is-loading');
		EPK.LpAga.$weekChangeButton.addClass('is-none');
		EPK.LpAga.$loadFilter.show();
*/
		target_date = $(this).data('target_date');
		start_date = $(this).data('start_date');
		page = $(this).data('page');
		EPK.LpAga.asyncDoctorList(target_date,start_date,page);
	});

	// 非ログイン時のモーダルを開く
	$(document).on('click','.mfp-open',function() {
		is_login = $(this).data('islogin');
		department_id = $(this).data('department_id');
		doctor_id = $(this).data('doctor_id');
		target_date = $(this).data('target_date');
		target_time = $(this).data('target_time');
		if (is_login == true) {
			EPK.LpAga.$signinModal.show();
			$('.mfp-signup').attr('data-department_id',department_id);
			$('.mfp-signup').attr('data-doctor_id',doctor_id);
			$('.mfp-signup').attr('data-target_date',target_date);
			$('.mfp-signup').attr('data-target_time',target_time);
			$('.mfp-login').attr('data-department_id',department_id);
			$('.mfp-login').attr('data-doctor_id',doctor_id);
			$('.mfp-login').attr('data-target_date',target_date);
			$('.mfp-login').attr('data-target_time',target_time);
		} else {
			window.location.href = "/remote/aga?department_id=" + department_id + "&doctor_id=" + doctor_id + "&target_date=" + target_date + "&target_time=" + target_time;
		}
	});

	// 新規会員登録へ遷移
	$(document).on('click','.mfp-signup',function() {
		is_login = $(this).data('islogin');
		department_id = $(this).data('department_id');
		doctor_id = $(this).data('doctor_id');
		target_date = $(this).data('target_date');
		target_time = $(this).data('target_time');

		window.location.href = "/signup?redirect_back=remote%2Faga%3Fdepartment_id%3D"
		+ department_id + "%26doctor_id%3D" + doctor_id + "%26target_date%3D" + target_date + "%26target_time%3D" + target_time;

	});

	// ログインへ遷移
	$(document).on('click','.mfp-login',function() {
		is_login = $(this).data('islogin');
		department_id = $(this).data('department_id');
		doctor_id = $(this).data('doctor_id');
		target_date = $(this).data('target_date');
		target_time = $(this).data('target_time');

		window.location.href = "/login?redirect_back=remote%2Faga%2Fselect%3Fdepartment_id%3D"
		+ department_id + "%26doctor_id%3D" + doctor_id + "%26target_date%3D" + target_date + "%26target_time%3D" + target_time;

	});

	// 非ログイン時のモーダルを閉じる
	$(document).on('click','.mfp-close',function() {
		EPK.LpAga.$signinModal.hide();
	});

	today = $('#day_for_first_calender_render');
	target_date = start_date = today.data('today');
	page = today.data('page');
	if ( target_date && page) {
		EPK.LpAga.asyncDoctorList(target_date,start_date,page);
	}
	if(this.location.pathname == '/lp/doctor_select/aga' || this.location.pathname == '/lp/doctor_select/faga'){
		EPK.LpAga.asyncDoctorSelectList();
	}

});

EPK.LpAga.asyncDoctorList = function (target_date,start_date,page) {
	EPK.LpAga.$hospitalCalendarScrollBox.addClass('is-loading');
	EPK.LpAga.$weekChangeButton.addClass('is-none');
	EPK.LpAga.$loadFilter.show();

	if (target_date && start_date && page) {

		// 日付部分の非同期
		$.ajax({
			type: 'GET',
			url: '/api/lpaga/get_week_list',
			data: {
				target_date: target_date,
				start_date: start_date,
				page: page
			},
			cache: false
		})
		.done(function(week_data) {
			// データを受け取る
			if (week_data) {
				$.ajax({
					type: 'GET',
					url: '/api/lpaga/get_reserve_list',
					data: {
						target_date: target_date,
						page: page
					},
					cache: false
				})
				.done(function(reserve_data) {
					if(reserve_data) {
						$('.week_list').empty();
						$('.week_list').append(week_data);
						EPK.LpAga.$previousWeek = $('.previous-week');
						EPK.LpAga.$nextWeek = $('.next-week');
						$('.reserve_list').empty();
						$('.reserve_list').append(reserve_data);
					}
				})
				.always(function() {
					EPK.LpAga.$loadFilter.hide();
					EPK.LpAga.$hospitalCalendarScrollBox.removeClass('is-loading');
					EPK.LpAga.$weekChangeButton.removeClass('is-none');
				});
			}
		})
		.fail(function(a,b,c) {
			console.log(a);
			console.log(b);
			console.log(c);
		})
	}

}

EPK.LpAga.asyncDoctorSelectList = function () {
	var page_info = $('.js_get_page_info');
	var p = page_info.data('p');
	var page = page_info.data('page');
	var target_date = page_info.data('target_date');
	var target_time = page_info.data('target_time');
	var doctors_count = EPK.RemoteAga.doctorsList.length;
	var active_count = 0;
	var resolved_count = 0;
	var data_lange_end = p*10;
	var data_lange_start = data_lange_end - 9;
	var view_doctors_list = [];

	$.each($('.doctor_select'), function(key, val) {
		var department_id, doctor_id, doctor_image_url, doctor_last_name, doctor_first_name, hospital_pref,
			hospital_city_name, hospital_department_name, hospital_name;

		department_id = $(val).data('department_id');
		doctor_id = $(val).data('doctor_id');
		doctor_image_url = $(val).data('doctor_image_url');
		doctor_last_name = $(val).data('doctor_last_name');
		doctor_first_name = $(val).data('doctor_first_name');
		hospital_pref = $(val).data('hospital_pref');
		hospital_city_name = $(val).data('hospital_city_name');
		hospital_department_name = $(val).data('hospital_department_name');
		hospital_name = $(val).data('hospital_name');

		if (department_id && doctor_id && target_date && target_time && page) {
			$.ajax({
				type: 'GET',
				url: '/api/lpaga/get_doctorselect_list',
				data: {
					department_id:department_id,
					doctor_id:doctor_id,
					doctor_image_url:doctor_image_url,
					doctor_last_name:doctor_last_name,
					doctor_first_name:doctor_first_name,
					hospital_pref:hospital_pref,
					hospital_city_name:hospital_city_name,
					hospital_department_name:hospital_department_name,
					hospital_name:hospital_name,
					target_date: target_date,
					target_time: target_time,
					page: page,
					p: p,
				},
				cache: false
			})
			.done(function(doctor_data) {
				if(doctor_data){
					active_count++;
					view_doctors_list[doctor_id] = doctor_data;
				}
			})
			.fail(function(a,b,c) {

			})
			.always(function(a,b,c) {

				resolved_count ++ ;

				if(resolved_count == doctors_count){
					var view_doctors_count = 0;
					var append_doctors_count = 0;
					view_doctors_list.sort();

					view_doctors_list.forEach(function(view_doctor){
						$('.doctor-select-loading').remove();
						view_doctors_count ++ ;
						if(view_doctors_count  >= data_lange_start && view_doctors_count  <= data_lange_end){
							$('.doctor-list').append(view_doctor).trigger("create");
							append_doctors_count ++ ;
						}
						if(append_doctors_count == 10){
							return true;
						}
					});

					$('.result-num').html('該当件数' + active_count + '件');

					$.ajax({
						type: 'GET',
						url: '/api/lpaga/get_doctorselect_paginator',
						data: {
							total_active_count : active_count,
							page : page,
							p : p,
							target_date: target_date,
							target_time: target_time,
						},
						cache: false
					})
					.done(function(pager) {
						if(pager) {
							$(".pager-list").append($(pager));
						}
					})
				}
			})
		}
	});
}
